// extracted by mini-css-extract-plugin
module.exports = {"root":"SitterPetCard_root__C1NjB","wrapper":"SitterPetCard_wrapper__s_h_5","name":"SitterPetCard_name__GEa6Q","description":"SitterPetCard_description__VwQP5"};